/* Progressive enhancement: independent, keyboard-operable Figma disclosures. */
(() => {
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('.ks-page [class$="__faq-list"] details').forEach(details => {
  const summary = details.querySelector('summary');
  if (!summary || details.dataset.knoxDisclosure) return;
  details.dataset.knoxDisclosure = 'ready';
  let animation;
  let expanded = details.open;
  summary.addEventListener('click', event => {
   event.preventDefault();
   expanded = !expanded;
   if (animation) animation.cancel();
   const from = details.getBoundingClientRect().height;
   if (reduced.matches || !details.animate) { details.open = expanded; return; }
   const style = getComputedStyle(details);
   const closed = summary.getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
   details.open = true;
   const to = expanded ? details.getBoundingClientRect().height : closed;
   details.style.overflow = 'hidden';
   animation = details.animate([{height:`${from}px`},{height:`${to}px`}], {duration:250,easing:'ease-in-out'});
   animation.onfinish = () => { details.open = expanded; details.style.overflow = ''; animation = null; };
  });
 });
})();

